import { type IntlShape } from 'react-intl-next';
import uuid from 'uuid';

import { type EditorState } from '@atlaskit/editor-prosemirror/state';
import { sectionCtaMessages } from '@atlassian/editor-plugin-company-hub-common/messages';

import {
	DEFAULT_BACKGROUND_COLOR,
	DEFAULT_CONTENT_WIDTH,
	hubElementPlaceholderExtensionKey,
	hubElementPlaceholderExtensionType,
	sectionExtensionKey,
	sectionExtensionType,
} from './constants';

// Section content structure
export const getSectionExtensionContents = ({
	header,
	subHeader,
	placeholderTitle,
}: {
	header: string;
	subHeader: string;
	placeholderTitle: string;
}) => ({
	type: 'extensionFrame',
	content: [
		{
			type: 'heading',
			attrs: {
				level: 1,
				localId: null,
			},
			content: [
				{
					type: 'text',
					text: `${header}`,
				},
			],
		},
		{
			type: 'paragraph',
			attrs: {
				localId: null,
			},
			content: [
				{
					type: 'text',
					text: `${subHeader}`,
				},
			],
		},
		{
			type: 'paragraph',
			attrs: {
				localId: null,
			},
		},
		{
			type: 'extension',
			attrs: {
				extensionKey: hubElementPlaceholderExtensionKey,
				extensionType: hubElementPlaceholderExtensionType,
				parameters: { extensionTitle: placeholderTitle },
				text: null,
				layout: 'default',
				localId: null,
			},
		},
	],
});

const sectionContentNode = (
	state: EditorState,
	initialContentText: {
		header: string;
		subHeader: string;
		placeholderTitle: string;
	},
) => state.schema.nodeFromJSON(getSectionExtensionContents(initialContentText));

export const newSectionNode = (state: EditorState, intl: IntlShape) => {
	const initialContentText = {
		header: intl.formatMessage(sectionCtaMessages.contentHeader),
		subHeader: intl.formatMessage(sectionCtaMessages.contentSubHeader),
		placeholderTitle: intl.formatMessage(sectionCtaMessages.placeHolderTitle),
	};
	return state.schema.nodes.multiBodiedExtension.create(
		{
			extensionType: sectionExtensionType,
			extensionKey: sectionExtensionKey,
			layout: 'full-width',
			localId: uuid(),
			parameters: {
				extensionTitle: intl.formatMessage(sectionCtaMessages.lozengeTitle),
				backgroundColor: DEFAULT_BACKGROUND_COLOR,
				contentWidth: DEFAULT_CONTENT_WIDTH,
			},
		},
		sectionContentNode(state, initialContentText),
	);
};
